<script>
import Details from '@/views/Application/Manage/Accounts/Account/Details'
export default {
  extends: Details,
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Details',
        route: { name: 'sales-accounts-account-details', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
